var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepositIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_3062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.14454 10.306C1.78613 12.3911 2.0983 14.5362 3.03612 16.4327C3.97395 18.3292 5.48912 19.8794 7.36369 20.8603C9.23827 21.8412 11.3757 22.2023 13.4684 21.8916C15.5612 21.5809 17.5015 20.6145 19.0103 19.1313C20.5191 17.6482 21.5186 15.7247 21.865 13.6375C22.2115 11.5504 21.887 9.40713 20.9384 7.51604C19.9897 5.62495 18.4657 4.08347 16.5855 3.11332C14.7053 2.14316 12.5659 1.79433 10.4749 2.11699L10.8145 4.31755C12.4399 4.06673 14.103 4.33789 15.5645 5.09203C17.026 5.84617 18.2107 7.04442 18.9481 8.51444C19.6856 9.98446 19.9378 11.6505 19.6685 13.2729C19.3992 14.8953 18.6222 16.3905 17.4494 17.5435C16.2765 18.6964 14.7683 19.4476 13.1415 19.6891C11.5147 19.9306 9.8532 19.65 8.39602 18.8875C6.93884 18.125 5.76104 16.9199 5.03203 15.4457C4.30302 13.9715 4.06036 12.304 4.33896 10.6832L2.14454 10.306Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.175 8.26801C14.447 7.73501 13.667 7.39701 12.731 7.28001V6.50001H11.6V7.25401C9.97501 7.39701 8.87001 8.34601 8.87001 9.75001V9.76301C8.87001 11.232 9.75401 11.947 11.652 12.428V14.989C10.807 14.846 10.105 14.456 9.36401 13.845L8.53201 15.041C9.41601 15.756 10.456 16.185 11.6 16.328V17.628H12.731V16.354C14.382 16.211 15.5 15.223 15.5 13.832V13.806C15.513 12.402 14.642 11.648 12.679 11.141V8.64501C13.29 8.78801 13.875 9.07401 14.447 9.49001L15.175 8.26801ZM13.966 13.923C13.966 14.547 13.511 14.95 12.679 15.041V12.675C13.68 12.974 13.966 13.325 13.966 13.897V13.923ZM10.404 9.64601C10.391 9.08701 10.82 8.65801 11.652 8.56701V10.868C10.651 10.556 10.404 10.205 10.404 9.65901V9.64601Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 2.00001H6.00001V8.00001H4.00001V2.00001Z",
    fill: "#2D64E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 4.00001V6.00001L2.00001 6.00001L2.00001 4.00001L8.00001 4.00001Z",
    fill: "#2D64E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_3062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIcon);
export default __webpack_public_path__ + "static/media/deposit-icon.7601e189d7978075af490e37c10c0406.svg";
export { ForwardRef as ReactComponent };